import { useMutation } from '@tanstack/react-query';
import { documentWorkflowControllerBulkRemindSignersMutation } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import type {
	BulkRemindSignersDto,
	StartBulkRemindSignersRes,
} from '@dealstack/shared/lib/backendClient';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const useBulkRemindSigners = ({
	dealId,
	programmeId,
	onSuccess,
	onSettled,
}: {
	dealId: string;
	programmeId: string;
	onSuccess?: (data: StartBulkRemindSignersRes) => void;
	onSettled?: () => void;
}) => {
	const tMipManage = useTranslationMipManage();

	const mutation = useMutation({
		...documentWorkflowControllerBulkRemindSignersMutation(),
		onSuccess,
		onError: () => {
			showToastV2({
				state: 'error',
				title: tMipManage('documents_page.toast.remind_signers.error'),
			});
		},
		onSettled,
	});

	return {
		mutate: (body: BulkRemindSignersDto) =>
			mutation.mutate({ path: { dealId, programmeId }, body }),
		isPending: mutation.isPending,
	};
};
